//=============================================================================
// Contents   : HRDB
//              従業員一覧
//              GetInformationList
// Author     : RV奥村
// LastUpdate : 2022/12/4
// Since      : 2022/12/3
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React,{ useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
import { screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { CFArrayFount, CFStringEncodeJP } from "03CommonApiParts/CommonFunction";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
/* ====== Style ====== */
import { GetListTemp } from "01Pages/Template/GetListTemp";
import { useProvideData } from "03CommonApiParts/use-context";
import { fileUploadS3 } from "03CommonApiParts/use-file";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";
import { assets } from "03CommonApiParts/Configuration";
import { Dialog } from "02CommonUiParts/MessageParts/Dialog";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ

/* ======================================================================== */  
/* ================================ dummy ================================= */  
/* ======================================================================== */

/* ========= 検索対象1データ ========= */
const statusMaster = {
    name:'検索対象',
    list:[
        {
            value: 'employeeList', 
            label: '従業員一覧',
        },
        {   
            value: 'change', 
            label: '変更',
            name:'受',
            type:'receptConfirmationState', 
        },
        {   
            value: 'acceptance', 
            label: '新規受入者',
        },
        {
            value: 'retire', 
            label: '退職者',
        },
    
    ]
};


/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 従業員一覧 ========= */
export const GetInformationList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    const location = useLocation();
    const apiData = useProvideData();//APIデータ取得

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */



    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== sessionStorageからの情報を定義 ====== */ 
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id
    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 




    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */
    const [disabledSearchYear ,setDisabledSearchYear] = useState(false);
    const [disabledSearchMonth ,setDisabledSearchMonth] = useState(false);
    const [disabledSearchKeyword ,setDisabledSearchKeyword] = useState(false);
    const [screenState ,setScreenState] = useState();
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    })

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== テーブルリストを押した時の処理 ====== */
    const onClickBodyRow = (event,row) => {
        event.preventDefault();
        navigate('/employee/information/detail',{state:{empNmb:row.empNmb}})
    };

    /* === 登録ボタンを押した時の処理 === */
    const onClickResister = () => {
        document.getElementById('fileUpload').click();
    };

    /* === ファイルアップロード時の処理 === */
    const handleFileSelect = async(event) => {
        /* プログレスバー表示 */
        setProgress(true);

        const file = event.target.files[0]; // ファイル情報を取得
        var fileId;

        /* リクエスト先 */
        const apiPath = '/common/getuploadurl';
        const apiPathBatch = '/employee/updatebatchemployee';

        /* リクエストデータ */
        const handlingInformation = {};
        var key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'REGISTER';

        /* キー */
        key.fileTypeCd = "batchUpdateExcelFileUploadFolder";
        key.fileName = CFStringEncodeJP(file.name, base64Swicth);
        key.cntType = CFStringEncodeJP(file.type, base64Swicth);

        /* リクエストパラメータ */
        var apiBody = {handlingInformation:handlingInformation, key:[key]};
        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, async(result) => {
			/* APIリクエスト結果を判定 */
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                fileId = result.responseData.data.payload[0].fileId;
                /* ファイルアップロード処理開始(取得した認証付きURL,ファイルデータ,コンテンツタイプ) */
                const uploadData = {
                    fileData: file,
                    contentType: file.type,
                    signedUrl: result.responseData.data.payload[0].sgnUrl//認証付きURL
                }
                await fileUploadS3(uploadData,async(uploadResut)=>{
                    if(uploadResut.isSuccessed){
                        // 操作IDを変更
                        handlingInformation.hndId = 'UPDATE';

                        /* キー */
                        key = {};
                        key.fileName = CFStringEncodeJP(file.name, base64Swicth)
                        key.fileId = fileId;
                        key.cntType = CFStringEncodeJP(file.type, base64Swicth);

                        /* リクエストパラメータ */
                        var apiBodyBatch = {handlingInformation:handlingInformation, key:key};
                        /* API処理開始 */
                        await apiData.getDataPost(apiPathBatch, apiBodyBatch, async(result) => {
                            document.getElementById('fileUpload').value = ''
                            /* プログレスバー非表示 */
                            setProgress(false);
                            /* APIリクエスト結果を判定 */
                            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                                navigate('/common/completion', {
                                    state:{
                                        title: `従業員一括編集`, 
                                        message: `${screenDisplayMessage('CMNI008')}\n更新データは${result.responseData.data.metadata.count}件です。`, //データの更新が完了しました。
                                        button:[
                                            {name: '一覧画面へ戻る', path: '/employee/information/list'}
                                        ]
                                        },
                                    replace:true
                                },);
                            }else{//APIリクエスト結果 = 異常
                                /* プログレスバー非表示 */
                                setProgress(false);
                                if(result.responseData.data.error.code === '200006' || !result.responseData.data.error.payload){//不正なリクエストキー
                                    /* スナックバー表示 */
                                    setSnackbarMessage({
                                        ...snackbarMessage,
                                        open:true,
                                        message:result,//APIによるエラー
                                        type: 1,//APIエラー時:1,それ以外:2 
                                        level:'error',//エラースナックバー
                                    });
                                }else{

                                    /* エラー表示内容編集 */
                                    const itemNameList = [
                                        { id:'empNmb',          name:'従業員番号'},
                                        { id:'empJpnSrname',    name:'姓'},
                                        { id:'empJpnName',      name:'名'},
                                        { id:'empJpnMidName',   name:'ミドルネーム'},
                                        { id:'empHnkuFrgnSrname',   name:'ｾｲ'},
                                        { id:'empHnkuFrgnName',     name:'ﾒｲ'},
                                        { id:'empFrgnMidName',  name:'ﾐﾄﾞﾙﾈｰﾑ'},
                                        { id:'empEngSrname',    name:'ローマ字 姓'},
                                        { id:'empEngName',      name:'ローマ字 名'},
                                        { id:'empEngMidName',   name:'ローマ字 ミドルネーム'},
                                        { id:'empAbrName',      name:'略名'},
                                        { id:'rkName',          name:'ランク'},
                                        { id:'gradeName',       name:'等級'},
                                        { id:'postName',        name:'役職'},
                                        { id:'dptCd',           name:'部署コード'},
                                        { id:'dptName',         name:'部署'},
                                        { id:'lboCstClasfName', name:'人件費区分'},
                                        { id:'cmntField',       name:'コメント欄'},
                                        { id:'aplySrtDate',     name:'適用日'}, 
                                        { id:'schedChgFlag',    name:'変更予定'},
                                        { id:'changePlan',    name:'変更予定'}//後で消す
                                    ];

                                    const validationList = [
                                        { id:'requiered', eng:'field is required', jp:'必須です'},
                                        { id:'number', eng:'must be  (.{1,3}) characters', jp:'桁で入力してください'},
                                        { id:'numberBetween', eng:'must be between  (.) and (.{1,3}) characters', jp:'桁で入力してください'},
                                        { id:'afterToday', eng:'must be equal or after today', jp:'今日以降の日付で入力してください'},
                                        { id:'invalid', eng:'invalid', jp:'正しいフォーマット入力してください'},
                                        { id:'string', eng:'must be a string', jp:'文字列で入力してください'},
                                    ];
                                    const consistencyCheckList = [
                                        { id:'', eng:'existsFutureDataInEmpInfo is true', jp:'フォーマット出力日以降に適用開始日が存在するため必須です'},
                                        { id:'invalid', eng:'invalid', jp:'存在しないデータです'},
                                    ];
                                    let errorMessage;
                                    result.responseData.data.error.payload.forEach((e)=>{
                                        let rowNum = e.split('.')[1];
                                        let itemName = CFArrayFount(itemNameList,'id',e.split('.')[2].split(':')[0]).name;
                                        /* payload1 フォーマット/バリデーションでエラー */
                                        if(e.split('.')[0] === 'payload1'){

                                            let validation = validationList.find(element =>e.match(new RegExp(element.eng)));
                                            let thisError;
                                            switch(validation.id){
                                                case'number'://桁数エラー
                                                    const charactersNum = new RegExp(validation.eng).exec(e)[1];
                                                    thisError = `${rowNum}行目の${itemName}は、${charactersNum}${validation.jp}。`;
                                                break;
                                                case'numberBetween'://桁数幅エラー
                                                    const hitData = new RegExp(validation.eng).exec(e);
                                                    const charactersNum1 = hitData[1];
                                                    const charactersNum2 = hitData[2];
                                                    thisError = `${rowNum}行目の${itemName}は、${charactersNum1}-${charactersNum2}${validation.jp}。`;
                                                break;
                                                default:
                                                    thisError = `${rowNum}行目の${itemName}は、${validation.jp}。`
                                                break;
                                            }
                                            errorMessage = errorMessage ? errorMessage + `\n${thisError}`: thisError;
                                        }
                                        /* payload2 整合性チェックでエラー */
                                        else{
                                            let consistency = consistencyCheckList.find(element =>e.match(new RegExp(element.eng)));
                                            let thisError = `${rowNum}行目の${itemName}は、${consistency?.jp ? consistency.jp:''}。`
                                            errorMessage = errorMessage ? errorMessage + `\n${thisError}`: thisError;
                                        };
                                        
                                    });
                                    /* OKボタン押下後の処理 */
                                    const afterFunc = () =>{
                                    };
                                    /* 確認ダイアログ表示 */
                                    setDialogMessage({
                                        ...dialogMessage,
                                        open:true, 
                                        message:errorMessage,//メッセージID(commonFunctionより対象のメッセージ)
                                        type:'text',
                                        afterFunc:afterFunc,
                                        pattern: 1//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                                    });
                                };
                            };
                        });
                    }else{ //①APIリクエスト結果 = 異常
                        document.getElementById('fileUpload').value = ''
                        /* プログレスバー非表示 */
                        setProgress(false);
                        /* エラーメッセージを表示 */
                        setSnackbarMessage({   //スナックバー表示   
                            ...snackbarMessage,
                            open:true,
                            message: uploadResut,//APIによるエラー
                            type: 1,//APIエラー時:1,それ以外:2 
                            level:'error',//エラースナックバー
                        });
                    };
                });
            }else{//APIリクエスト結果 = 異常
                document.getElementById('fileUpload').value = ''
                /* プログレスバー非表示 */
                setProgress(false);
                /* スナックバー表示 */
                setSnackbarMessage({
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2
                    level:'error',//エラースナックバー
                });
                return;
            };
        });

    };
    const disableSelectBox = (event) => {
        if (event === 'employeeList') {
            setDisabledSearchYear(false)
            setDisabledSearchMonth(false)
            setDisabledSearchKeyword(false)
            setScreenState(event)
        } else if (event === 'change' || event === 'acceptance' || event === 'retire') {
            setDisabledSearchYear(true)
            setDisabledSearchMonth(true)
            setDisabledSearchKeyword(false)
            setScreenState(event)
        }
    }

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== 取得API項目の設定 ====== */
	const getConfig = {
        key:[
            {name:'sarTrg' , base64:false},
            {name:'sarYear' , base64:false},
            {name:'sarMonth' , base64:false},
            {name:'sarLiteral' , base64:true}
        ],
        payload:[
            {name:'empNmb',                     base64:false},
            {name:'empJpnSrname',               base64:true},
            {name:'empJpnName',                 base64:true},
            {name:'empFrgnSrname',              base64:true},
            {name:'empFrgnName',                base64:true},
            {name:'empHnkuFrgnSrname',          base64:true},
            {name:'empHnkuFrgnName',            base64:true},
            {name:'empAbrName',                 base64:true},
            {name:'empiSttsName',               base64:true},
            {name:'rkName',                     base64:true},
            {name:'tmpAgnSecFrmCmpName',        base64:true},
            {name:'gendName'	,               base64:true},
            {name:'mnaSpvrName',                base64:true},
            {name:'postName',                   base64:true},
            {name:'dptCd',                      base64:false},
            {name:'dptHqName',                  base64:true},
            {name:'dptPartName',                base64:true},
            {name:'dptRomName',                 base64:true},
            {name:'dptGpName',                  base64:true},
            {name:'dptOrd',                     base64:false},
            {name:'lboCstClasfName',            base64:true},
            {name:'entryDate',                  base64:false},
            {name:'rtiDate',                    base64:false},
            {name:'aplySrtDate',                base64:false},
            {name:'cmntField',                  base64:true},
            {name:'mailAcnt',                   base64:false},
            {name:'mailAdrs',                   base64:false},
            {name:'domain',                     base64:false},
            {name:'pcAcnt',                     base64:true},
            {name:'bsiTripExpeAjuSec',          base64:true},
            {name:'lastUdr',                    base64:true},
            {name:'lastUpDate',                 base64:false},
            {name:'upItemName',                 base64:false},
            {name:'chgList',                    
                list:[
                    {name:'chgItemName',        base64:true},
                    {name:'chgBfItemCont',      base64:true},
                    {name:'chgAftItemCont',     base64:true}
                ]
            },
            {name:'asiFlag',                    base64:false},
            {name:'moveInFlag',                    base64:false}
        ]              
    };


    /* ======== テーブルの設定 ======== */
    /*------ ヘッダの設定 ------*/
    // id       : 項目名
    // id2       : 項目名2
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　true

    /* ====== テーブルヘッダーを定義 ====== */
    const headData = [
    	{ id: 'empNmb', align: 'left', width: '120px', sortTable:true, label1: '従業員番号' ,fixed:true,left:'0px'},//従業員番号
        { id: 'empJpnSrname', align: 'left', width: '120px', sortTable:true, label1: '氏名' ,fixed:true,left:'124px' ,borderRight:'1px solid #c0c0c0'},//氏名
        { id: 'empFrgnSrname', align: 'left', width: '130px', sortTable:true, label1: 'フリガナ'},//フリガナ
        { id: 'empiSttsName', align: 'left', width: '130px', sortTable:true, label1: '雇用形態'},//雇用形態
    	{ id: 'rkName', align: 'left', width: '100px', sortTable:true, label1: 'ランク' },//ランク
    	{ id: 'tmpAgnSecFrmCmpName', align: 'left', width: '200px', sortTable:true, label1: '派遣元・出向元会社' },//派遣元・出向元会社
        { id: 'gendName', align: 'left', width: '80px', sortTable:true, label1: '性別' },//性別
        { id: 'mnaSpvrName', align: 'left', width: '130px', sortTable:true, label1: '管理監督者' },//管理監督者
        { id: 'postName', align: 'left', width: '70px', sortTable:true, label1: '役職'},
        { id: 'dptCd', align: 'left', width: '130px', sortTable:true, label1: '部署コード' },//部署コード
        { id: 'dptHqName', align: 'left', width: '250px', sortTable:true, label1: '部署' },//部署
        { id: 'dptOrd', align: 'left', width: '100px', sortTable:true, label1: '部署順' },//部署順
        { id: 'lboCstClasfName', align: 'left', width: '100px', sortTable:true, label1: '人件費',label2: '区分'  },//人件費区分
        { id: 'entryDate', align: 'left', width: '115px', sortTable:true, label1: '入社日' },//入社日(開始日)
        { id: 'rtiDate', align: 'left', width: '115px', sortTable:true, label1: '退職日' },//退職日(終了日)
        { id: 'aplySrtDate', align: 'left', width: '115px', sortTable:true, label1: '適用開始日' },
        { id: 'cmntField', align: 'left', width: '240px',  label1: 'コメント欄' },
        { id: 'mailAdrs', align: 'left', width: '240px', sortTable:true, label1: 'メールアドレス' },
        { id: 'bsiTripExpeAjuSec', align: 'left', width: '110px', sortTable:true, label1: '旅費精算',label2:'(出向)' },
        { id: 'lastUdr', align: 'left', width: '120px', sortTable:true, label1: '最終更新者' },
        { id: 'lastUpDate', align: 'left', width: '115px', sortTable:true, label1: '最終更新日'}
    ];
    const headData2 = [...headData];
    headData2.push( 
        { id: 'chgList', align: 'left', width: '300px', sortTable:false, label1: '変更内容'}
    );
   
    /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton
    /* ====== テーブルデータを定義 ====== */
    const bodyData = [
        { name: 'empNmb', type: 'label',  align: 'left',fixed:true,left:'0px'},
        { name: 'empJpnSrname', name2:'empJpnName', type: 'label', fixed:true, align: 'left',left:'124px',borderRight:'1px solid #c0c0c0',otherItemCheck:{item:'upItemName',color:assets().color.lightYellow}},
        { name: 'empFrgnSrname', name2:'empFrgnName', type: 'label', align: 'left'},
        { name: 'empiSttsName', type: 'label',  align: 'left'},
        { name: 'rkName', type: 'label',  align: 'left',otherItemCheck:{item:'upItemName',color:assets().color.lightYellow}},
        { name: 'tmpAgnSecFrmCmpName', type: 'label',  align: 'left'},
        { name: 'gendName', type: 'label',  align: 'left'},
        { name: 'mnaSpvrName', type:'label', align: 'left', colorCheckItem:'upItemName', otherItemCheck:{item:'upItemName',color:assets().color.lightYellow}},
        { name: 'postName', type: 'label',  align: 'left',otherItemCheck:{item:'upItemName',color:assets().color.lightYellow}},
        { name: 'dptCd', type: 'label',  align: 'left',otherItemCheck:{item:'upItemName',color:assets().color.lightYellow}},
        { name: 'dptHqName', name2:'dptPartName', name3:'dptRomName', name4:'dptGpName', type: 'label',  align: 'left',otherItemCheck:{item:'upItemName',color:assets().color.lightYellow}},
        { name: 'dptOrd', type: 'label',  align: 'left'},
        { name: 'lboCstClasfName', type: 'label',  align: 'left'},
        { name: 'entryDate', type: 'dateLabel',  align: 'left'},
        { name: 'rtiDate', type: 'dateLabel',  align: 'left'},
        { name: 'aplySrtDate', type: 'dateLabel',  align: 'left'},
        { name: 'cmntField', type: 'label',  align: 'left'},
        { name: 'mailAdrs', type: 'label',  align: 'left',empty:true, otherItemCheck:{item:'upItemName',color:assets().color.lightYellow},valueCheck:{value:'', color:assets().color.pink}},
        { name: 'bsiTripExpeAjuSec', type: 'label',  align: 'left'},
        { name: 'lastUdr',type: 'label', align: 'left'},
        { name: 'lastUpDate',type: 'timeLabel', align: 'left'},

    ];
    const bodyData2 = [...bodyData];
    bodyData2.push( 
        { name: 'chgList',type: 'label', align: 'left'}
    );

    /* ======== エクセルの設定 ======== */
    const excelConfig = [
		{ id:'empiSttsName', name:'雇用形態', type:'normal'},
		{ id:'rkName', name:'ランク', type:'normal',otherItemCheck:{item:'upItemName',color:'#FFFF00'}},
		{ id:'tmpAgnSecFrmCmpName', name:'派遣元・出向元', type:'normal'},
		{ id:'empNmb', name:'従業員番号', type:'normal'},
		{ id:'empJpnSrname', name:'姓', type:'normal'},
		{ id:'empJpnName', name:'名', type:'normal'},
		{ id:'empFrgnSrname', name:'セイ', type:'normal'},
		{ id:'empFrgnName', name:'メイ', type:'normal'},
		{ id:'empHnkuFrgnSrname', name:'ｾｲ', type:'normal'},
		{ id:'empHnkuFrgnName', name:'ﾒｲ', type:'normal'},
		{ id:'empAbrName', name:'略名', type:'normal'},
		{ id:'empJpName', id1:'empJpnSrname',id2:'empJpnName', name:'氏名', type:'multiple',otherItemCheck:{item:'upItemName',color:'#FFFF00'}},
		{ id:'empFrName', id1:'empFrgnSrname',id2:'empFrgnName' , name:'フリガナ', type:'multiple'},
		{ id:'gendName', name:'性別', type:'normal'},
		{ id:'mnaSpvrName', name:'管理監督者', type:'normal',otherItemCheck:{item:'upItemName',color:'#FFFF00'}},
		{ id:'postName', name:'役職', type:'normal',otherItemCheck:{item:'upItemName',color:'#FFFF00'}},
		{ id:'dptCd', name:'部署コード', type:'normal',otherItemCheck:{item:'upItemName',color:'#FFFF00'}},
		{ id:'dpt', id1:'dptHqName', id2:'dptPartName', id3:'dptRomName', id4:'dptGpName', name:'部署', type:'multiple',otherItemCheck:{item:'upItemName',color:'#FFFF00'}},
		{ id:'dptHqName', name:'本部', type:'normal'},
		{ id:'dptPartName', name:'部', type:'normal'},
		{ id:'dptRomName', name:'室', type:'normal'},
		{ id:'dptGpName', name:'G', type:'normal'},
		{ id:'dptOrd', name:'部署順', type:'normal'},
		{ id:'lboCstClasfName', name:'人件費区分', type:'normal'},
		{ id:'entryDate', name:'入社日(開始日)', type:'date'},
		{ id:'rtiDate', name:'退職日(終了日)', type:'date'},
		{ id:'aplySrtDate', name:'適用日', type:'normal'},
		{ id:'cmntField', name:'コメント欄', type:'normal'},
		{ id:'mailAdrs', name:'メールアドレス', type:'normal',otherItemCheck:{item:'upItemName',color:'#FFFF00'},valueCheck:{value:'', color:'#FFC0CB'}},
		{ id:'mailAcnt', name:'アドレス', type:'normal'},
		{ id:'domain', name:'ドメイン', type:'normal'},
		{ id:'pcAcnt', name:'PCアカウント', type:'normal'},
		{ id:'bsiTripExpeAjuSec', name:'旅費精算(出向)', type:'normal'},
		{ id:'lastUdr', name:'最終更新者', type:'normal'},
		{ id:'lastUpDate', name:'最終更新日', type:'time'}
	]

    /* ======== ページヘッダーの設定 ======== */
    /*------ ページヘッダーの設定 ------*/
    // id         : 項目名
    // name       : 項目名
    // type       : 種類 input/select/checked/searchButton/clearButton
    // range      : selectbox中身
    // type       : 種類 input/select/checked/searchButton/clearButton
    // width      : 幅幅調整用
    // maxLength  : 最大桁数を定義
    // minLength  : 最小桁数を定義
    // placeholder: Input内のテキスト
    // required   : 必須定義
    // disabled   : 操作不可
    // func       : 処理 *button,iconButton,select
    // checked    :defoltCheckを定義

    /* ====== 検索欄(左)を定義 ====== */
    const searchContentsLeft = [
        {id:'sarTrg',name:'検索対象',type:'radio',range:statusMaster},
        {id:'sarYear',name:'検索年',type:'year',disabled:disabledSearchYear,required:false, requireCheckItem:'sarMonth'},
        {id:'sarMonth',name:'検索月',type:'month',disabled:disabledSearchMonth,required:false, requireCheckItem:'sarYear'},
        {id:'sarLiteral',type:'input',name:'検索文字',placeholder:'',maxLength:50,width:'280px',disabled:disabledSearchKeyword, pattern:'keyword'},
        {id:'search',type:'searchButton'},
        {id:'clear',type:'clearButton'},
    ];

    /* ====== 検索欄(右)を定義 ====== */
    const searchContentsRight = [
        {id:'download',type:'formatDownloadButton', path: '/employee/information/format'},
        {id:'resister',type:'resisterButton', func: onClickResister},
        {id:'excel',type:'excelButton', excelTitle:'人件費経費負担先', excelConfig:excelConfig},
       
    ];

    /* ====== 検索初期値を定義 ====== */
    const defaultSearch = {
        sarTrg:'employeeList',
        sarYear:'',
        sarMonth:'',
        sarLiteral:'',
    }

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバー */}
            <LoadingProgressBar open={progress}/>
			<GetListTemp
				listType='list'//一覧タイプ(list:編集なし/listEditable:編集可/listOrderBy:表示順更新)
                initialSearch={true}//初期検索有無
                searchCount={true}//検索件数表示
				pageTitle='従業員一覧'//画面タイトル
                searchContentsLeft={searchContentsLeft}//検索欄左設定
				searchContentsRight={searchContentsRight}//検索欄右設定
				apiPath='/employee/getlistemployee'
                defaultSearch={defaultSearch}//初期検索値
				headData={screenState === 'change' ? headData2 : headData}//テーブルヘッダ設定 
				bodyData={screenState === 'change' ? bodyData2 : bodyData}//テーブルボディ設定
                getConfig={getConfig}//テーブル取得設定
                onClickBodyRow={onClickBodyRow}//行クリックの処理
                disableSelectBox={disableSelectBox}
			/>
            <input 
                id='fileUpload' 
                type='file' 
                accept=".xlsx" 
                hidden 
                onChange={(event) => handleFileSelect(event)}
            />
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
            />
            {/* ダイアログ */}
            <Dialog
				content={dialogMessage}
				set={setDialogMessage}
			/>
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 